exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.card{position:relative;margin:1rem;padding:1rem;width:60%;background-color:#fff;border-radius:.25rem;border-bottom:4px solid #555;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}@media (max-width:599px){.card{width:70%}}@media (min-width:1024px){.card{width:35%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/card/styles.scss
// module id = 1020
// module chunks = 0